/**
 * @desc kewl
 */
import updateLocation2 from './location2';
import { utility, WinMap, sysMap } from './utility.js';
import { KEWLApp, Base64 } from './kewl.js';
import ISONLINE from './domainJudge.js';

// 公共参数
const publicPram = {
  userid: '', // 用户id   如果没有登录为空    string
  account: '', // uuid    string
  liveid: '', // 直播间ID   vid   string
  br: '', // 当前浏览器 string
  brv: '', // 浏览器版本 string
  dis_pc: '', // 浏览器尺寸 string
  dis_br: '', // 屏幕尺寸  string
  network: 0, // 当前网络环境    byte  0
  logintype: 0, // 登录状态   short   0=fb 1=
  country_sysyem: '', // 系统用户国家码 string
  channel: '', // 来源渠道 string
  pagetype: 0, // 页面形式 byte    1 web 2 h5
  system: 0, // 主机系统 byte
  brand: '', // 主机品牌 string
  ver: '', // 版本号 string string
  logtime: 0, // 用户注册天数 short
  tmzone: 0, // 用户所在时区 short
  uptime: 0, // 用户本地当前时间 int
  referrer: '', // document.referrer
  url: '' // location2.href
};
const pf = navigator.platform;
const ua = navigator.userAgent;
const { href } = window.location2;
const locSearch = window.location2.search;

// 初始化获取公共参数
function initPublicParams() {
  const lua = ua.toLowerCase();
  let match;
  let version;
  let i;
  let j;
  let system;
  let device;
  let browser;
  let tmzong;
  let uptime;
  let network;
  let networkType;
  let countryCode;
  let pagetype;
  let dis_pc;
  let dis_br;
  let channel;
  let uuid;
  for (i in sysMap) {
    if (sysMap.hasOwnProperty(i) && lua.indexOf(i) > -1) {
      if (typeof sysMap[i] === 'object') {
        for (j in sysMap[i]) {
          if (sysMap[i].hasOwnProperty(j) && lua.indexOf(j) > -1) {
            system = sysMap[i][j];
            break;
          }
        }
      } else {
        system = sysMap[i];
      }
      break;
    }
  }
  if (system === 18 || system === 19 || system === 20) {
    device = 'Mac';
  } else if (system === 16 || system === 17) {
    match = /iPad|iPhone/.exec(ua);
    device = (match && match[0]) || device;
  } else if (system === 15) {
    device = 'Mobile';
  }
  match = /(chrome)[ \/]([\w.]+)/i.exec(lua)
     || /(AppleWebKit)[ \/]([\w.]+)/i.exec(lua)
     || /ms(ie)\s([\w.]+)/i.exec(lua)
     || /(safari)[ \/]([\w.]+)/i.exec(lua)
     || /(firefox)[ \/]([\w.]+)/i.exec(lua)
     || [];
  if (match && match[1]) {
    browser = match[1];
    version = match[2];
    console.info(version);
  }
  // 浏览器尺寸
  dis_pc = `${window.innerWidth}*${window.innerHeight}`;
  dis_br = `${window.screen.width}*${window.screen.height}`;
  // 网络
  networkType = navigator.connection && navigator.connection.type
    ? navigator.connection.type
    : '0';
  networkType = networkType.toLowerCase();
  if (networkType.indexOf('wifi') > -1) {
    network = 1;
  } else if (networkType.indexOf('2g') > -1) {
    network = 2;
  } else if (networkType.indexOf('3g') > -1) {
    network = 3;
  } else if (networkType.indexOf('4g') > -1) {
    network = 4;
  } else {
    network = 0;
  }
  // country code
  countryCode = window.navigator.userLanguage || window.navigator.language;
  // channel
  channel = utility.getQueryString('f')
    ? utility.getQueryString('f')
    : utility.getQueryString('from')
      ? utility.getQueryString('from')
      : utility.getQueryString('channel')
        ? utility.getQueryString('channel')
        : utility.getQueryString('source')
          ? utility.getQueryString('source')
          : '0';
  // pagetype
  pagetype = KEWLApp && KEWLApp.isKEWLApp ? 3 : utility.isMobile() ? 2 : 1;
  // uuid;
  console.info(utility.getCookie('uuid'));
  uuid = utility.getCookie('uuid');
  if (!uuid) {
    uuid = utility.createUUID();
    utility.setCookie('uuid', uuid, {
      expires: 365
    });
  }
  publicPram.account = uuid;
  publicPram.br = browser;
  publicPram.brv = version;
  publicPram.dis_pc = dis_pc;
  publicPram.dis_br = dis_br;
  publicPram.network = network;
  publicPram.country_sysyem = countryCode.split('-')[1];
  publicPram.channel = channel;
  publicPram.pagetype = pagetype;
  publicPram.system = system;
  publicPram.brand = device;
  //            publicPram.ver = "1.4.1"; //
  publicPram.ver = window.navigator.userAgent; //
  publicPram.tmzone = Math.abs(new Date().getTimezoneOffset() / 60); // 时区
  publicPram.uptime = Math.round(new Date().getTime() / 1000);
  publicPram.referrer = document.referrer;
  publicPram.url = location2.href;
  // todo 实时获取的数据：publicPram.userid   publicPram.liveid  publicPram.logintype publicPram.logtime
  // 如果是APP内使用  获取userinfo
  if (KEWLApp && KEWLApp.isKEWLApp) {
    KEWLApp.getUserInfo((data) => {
      const userInfo = typeof data === 'string' && data !== 'null' && data !== ''
        ? JSON.parse(data)
        : data;
      if (
        userInfo instanceof Object
         && userInfo.userId
         && userInfo.token
         && userInfo.deviceId
      ) {
        publicPram.userid = userInfo.userId;
      }
    });
    // 页面加载之后上报数据给客户端用于统计页面性能
    const currentVer = KEWLApp.getVerName();
    if (utility.versionCompare(currentVer, '4.0.95')) {
      document.onreadystatechange = function () {
        if (
          document.readyState == 'complete'
           && KEWLApp.pageFinish
           && typeof KEWLApp.pageFinish == 'function'
           && typeof performance.getEntries == 'function'
        ) {
          KEWLApp.pageFinish(
            location2.href,
            JSON.stringify(performance.getEntries()[0])
          );
        }
      };
    }
  } else {
    const userInfo = localStorage.getItem('userInfo')
      ? JSON.parse(Base64.fromBase64(localStorage.getItem('userInfo')))
      : '';
    //    publicPram.network = userInfo ? userInfo.user.gold : 0;
    publicPram.userid = userInfo ? userInfo.user.uid : '';
    publicPram.liveid = utility.getQueryString('videoid');
    // 用户选择登录的时候纪录登录方式 logintype
    const loginType = localStorage.getItem('regType') || 0;
    publicPram.logintype = loginType;
    publicPram.logtime = userInfo && userInfo.user && userInfo.user.reg_time
      ? Math.round(
        (new Date().getTime() - parseInt(`${userInfo.user.reg_time}000`))
               / 3600
               / 24
               / 1000
      )
      : 0;
  }
}
initPublicParams();

function KEWLOldReport(config) {
  if (!config.businessIndex || !config.params) {
    throw new Error('please config businessIndex and params');
  }
  this.businessIndex = config.businessIndex;
  this.businessParams = config.params;
  this._businessParams = utility.copy(config.params);
  this.domainUrl = ISONLINE
    ? `${location2.protocol}//liveme-up.liveme.com`
    : 'http://118.89.55.235/g/v1/';
}
KEWLOldReport.prototype.report = function (params) {
  if (typeof params === 'object') {
    for (const i in this.businessParams) {
      if (
        params.hasOwnProperty(i)
         && this.businessParams.hasOwnProperty(i)
         && params[i]
      ) {
        this.businessParams[i] = params[i];
      } else {
        this.businessParams[i] = this._businessParams[i];
      }
    }
  }
  // 公共字段
  const public_index = utility.buildQuery(publicPram);
  // 业务字段
  const business_index = utility.buildQuery(this.businessParams);
  const allParams = {
    product_no: 184,
    public_index: 3,
    business_index: this.businessIndex
  };
  const url = `${this.domainUrl
  }?${
    utility.buildQuery(allParams)
  }&${
    public_index
  }&${
    business_index}`;
  console.info(decodeURIComponent(url));
  // utility.create(url)
};
const _KEWLOldReportName = atob('S0VXTEluZm9j');
const _KEWLOldReport = KEWLOldReport;
KEWLOldReport.noConflict = function (deep) {
  if (window[_KEWLOldReportName] === KEWLOldReport) {
    window[`_${_KEWLOldReportName}`] = KEWLOldReport;
  }
};

window[_KEWLOldReportName] = KEWLOldReport;

export default KEWLOldReport;
